import { deserialize } from 'cerialize'
import { ReserveAccountStatus } from 'Pages/orders_design'
import { Moment } from 'moment/moment'

type TStatusReserve = {
	status_code: number
	status_desc?: string
}
type TLastExternalRequest = {
	created_at?: string
	rquid?: string
}
export class ReserveAccountModel {
	@deserialize public id: number
	@deserialize public sber_geo_unit_address: string
	@deserialize public package_of_service: string
	@deserialize public cm_visit_flag: 0 | 1
	@deserialize public sber_geo_unit_code_nsi: number
	@deserialize public sber_geo_unit_branch_address_string: string | null
	@deserialize public status: ReserveAccountStatus | null
	@deserialize public status_list: TStatusReserve
	@deserialize public created_at: Moment
	@deserialize public kpp: string
	@deserialize public ogrn: string
	@deserialize public okopf: string
	@deserialize public okfs?: string
	@deserialize public last_external_request?: TLastExternalRequest
	@deserialize public status_hint: string
	@deserialize public date?: string
	@deserialize public time_from?: string
	@deserialize public time_to?: string
	@deserialize public city?: string
	@deserialize public region?: string
	@deserialize public description?: string
	@deserialize public longitude?: string
	@deserialize public latitude?: string
	@deserialize public cm_appointment_create_tag?: string | null
}
